import type { GetStaticProps } from 'next';
import { fetchServicesPageStrapiData } from '../utils/api/fetchStrapiData';
import { Services } from '../views/LatestServices/Services';

export const getStaticProps: GetStaticProps = async () => {
  const data = await fetchServicesPageStrapiData();

  return {
    props: data,
  };
};

export default Services;
